export enum Lang {
    Ru = 1,
    En = 2,
}
